

export class RfCodeRequest {
    rfCode: string;
    username: string;

    /**
     * 
     * @param rfCode 
     * @param username 
     */
    constructor(rfCode: string, username: string) {
        this.rfCode = rfCode;
        this.username = username;
    }
}